'use strict';

class Sidebar {
  constructor($scope, $location, userService, originatorService) {
    this.$scope = $scope;
    this.$location = $location;
    this.userService = userService;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.links = [];

    this.load();

    this.$scope.$on('$locationChangeSuccess', () => {
      // this.load();
      this.highlight();
    });

    this.$scope.$on('originatorSettingsUpdated', () => {
      this.load();
    });
  }

  load() {
    // console.log('--- side bar');
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        this.userService.get()
          .then((user) => {
            this.links = [{
              title: 'Beta-program',
              icon: 'fa fa-cogs',
              path: '/side/#/beta',
              visible: user.data.level === 'BETA' || user.data.level === 'ALPHA'
            }, {
              title: null,
              icon: null,
              path: null,
              visible: user.data.level === 'BETA' || user.data.level === 'ALPHA'
            }, {
              title: 'Ny regning',
              icon: null,
              path: this.originator.giroLayout ? '/side/#/regning/kladd/ny' : '/side/#/regning/kladd/utengiro/ny',
              visible: true
            }, {
              title: 'Oversikt',
              icon: null,
              path: '/side/#/oversikt',
              visible: true
            }, {
              title: 'Beslutning kreves',
              icon: null,
              path: '/side/#/beslutning-kreves',
              visible: true
            }, {
              title: null,
              icon: null,
              path: null,
              visible: true
            }, {
              title: 'Kundeliste',
              icon: null,
              path: '/side/#/kundeliste',
              visible: true
            }, {
              title: 'Produktliste',
              icon: null,
              path: '/side/#/produkt',
              visible: true
            }, {
              title: 'Rapporter',
              icon: null,
              path: '/side/#/rapport',
              visible: true
            }, {
              title: null,
              icon: null,
              path: null,
              visible: true
            }, {
              title: 'Tilbud',
              icon: null,
              path: '/side/#/tilbud',
              visible: true
            }, {
              title: 'Ordrebekreftelse',
              icon: null,
              path: '/side/#/ordrebekreftelse',
              visible: true
            }, {
              title: 'Fast oppdrag',
              icon: null,
              path: '/side/#/fast-oppdrag',
              visible: true
            }, {
              title: 'Masseutsendelse',
              icon: null,
              path: '/side/#/masseutsendelse',
              visible: true
            }, {
              title: 'Arrangement',
              icon: null,
              path: '/side/#/vert',
              visible: true
            }, {
              title: 'Timeregistrering',
              icon: null,
              path: '/side/#/timeregistrering',
              // visible: user.data.level === 'BETA' || user.data.level === 'ALPHA'
              visible: true
            }, {
              title: null,
              icon: null,
              path: null,
              visible: true
            }, {
              title: 'Personvern (GDPR)',
              icon: null,
              path: '/side/#/personvern',
              visible: true
            }];

            this.highlight();
          });
      });
  }

  status(feature, list) {
    let count = 0;

    if (list) {
      list.forEach((f) => {
        if (f === feature) {
          count += 1;
        }
      });
    }

    // if found
    if (count) {
      return true;
    }

    return false;
  }

  cleanUrl(path) {
    let cleaned = path;

    if (path && path.indexOf('/side/#') !== -1) {
      cleaned = path.replace('/side/#', '');
    }

    return cleaned;
  }

  highlight() {
    let path = this.$location.path();

    if (path && this.links.length) {
      this.links.forEach((link) => {
        link.active = false;

        if (path === this.cleanUrl(link.path)) {
          link.active = true;
        }
      }, this);
    }
  }
}

Sidebar.$inject = ['$scope', '$location', 'userService', 'originatorService'];

const sidebar = {
  controller: Sidebar,
  template: `
    <aside id="sidebar" role="navigation">
      <ul class="side-nav">
        <li ng-repeat="l in $ctrl.links track by $index" ng-if="l.visible" ng-class="{ divider: !l.path, active: l.active }">
          <a href="{{ l.path }}" ng-if="l.title">
            <i class="{{ l.icon }}" ng-if="l.icon"></i> {{ l.title }}
          </a>
        </li>
      </ul>
    </aside>
  `
};

angular
  .module('SendRegning')
  .component('sidebar', sidebar);
